export const VALIDATE_STATEMENT_CATEGORIZATION = 'VALIDATE_STATEMENT_CATEGORIZATION';
export interface ReduceValidateStatementCategorizationAction {
    type: typeof VALIDATE_STATEMENT_CATEGORIZATION,
    payload: PostingFilter
}
